import actions, { withProductLine } from '../../actions/GenericBenefitsSets'
import { connectPlanSharedBusinessRules } from '../PlanSharedBusinessRules/CreateBusinessRulesShow'

export default connectPlanSharedBusinessRules('Critical Illness',
  withProductLine('critical_illness', actions.show.main),
  actions.show.reset,
  true)
